import { toast } from "react-toastify";
import ApiService from "../../../services/apiService";
import Add from "../../table/Add"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const WaterChargesAdd = () =>{

    const [dropdownOpen,setDropdownOpen] = useState(false);
    const navigate = useNavigate();
   
    
      const onSubmit = async (data :any) => {
        try{
            
            const response = await ApiService.axiosApi("/watercharges",{
                method: "POST",
                data: data,
            })
            if(response.success){
               
                toast.success(response.message);
                navigate(-1);
            }else{
                toast.error(response.message);
            }
        }catch(error){
            console.log(error);
        }
      }
    
     
      const toggleDropdown = () => setDropdownOpen(prev => !prev);
    return(
        <>
        <Add
         title = {'Add Water Charges'}
         parentTitle = {'Water Charges'}
         onSubmit = {onSubmit}

         fields = {[
             {
              name : "UnitPrice",
              label  :"Unit Price",
              type: "text",
              validation :  { required: "Scheme Village is required" }
             },
             {
              name : 'EffectiveFrom',
              label : 'EffectiveFrom',
              type : 'dateTime',
              validation :  { required: "EffectiveFrom is required" }

             }
             
         ]}
        />

      </>
    )
}

export default WaterChargesAdd